<div class="flex-c gap-16 max-width-800 padding-bottom-48">
  <div class="flex-r justify-end">
    <button
      id="desktop-delete-button"
      class="inwi-icon-text-button-medium-secondary"
      (click)="onGenerateCouponCodes()">
      <div class="button-content">
        <div class="button-icon">
          <i class="fa-regular fa-plus"></i>
        </div>
        <div class="button-text">Neue Gutscheine erstellen</div>
      </div>
    </button>
  </div>
  @if (!isLoading) {
    @for (coupon of sellableCodes; track $index) {
      <app-coupon
        style="min-height: 164px"
        [coupon]="coupon"
        [adminView]="true"
        (couponDeleted)="onCouponDeleted($event)"
        (couponActiveStateChanged)="
          onCouponActiveStateChanged($event, coupon.id)
        "></app-coupon>
    }
    <p-divider type="dashed" class="divider-with-button padding-12-0">
      <button class="circle-medium" (click)="addSellableCode()">
        <i class="fa-solid fa-plus circle-icon"></i>
      </button>
    </p-divider>
  } @else {
    @for (item of [].constructor(4); track $index) {
      <p-skeleton width="100%" height="164px"></p-skeleton>
    }
  }
</div>
